import './car-select.styles.scss';

import CarSelectController from './car-select.controller';

export default angular.module('directives.carSelect', [])
  .directive('carSelect', ($http) => {
    'ngInject';

    return {
      controller: CarSelectController,
      restrict: 'E',
      replace: true,
      scope: {
        additionalSearchParam: '@', // Values, which will be used to find a car
        fsModel: '=', // ng-model
        placeholder: '@',
        required: '@',
        carInit: '=',
        vinInit: '@?', // if set search the data and preselect if found.
        includeSold: '@?',
      },
      templateUrl: require('./car-select.template.html'),
      link: (scope) => {
        const filter = scope.includeSold ? {
          'vehicleData.inventory.state': {
            $in: ['ORDERED', 'STOCK', 'SOLD'],
          },
        } : {
          'vehicleData.inventory.state': {
            $in: ['ORDERED', 'STOCK'],
          },
        };
        const query = `?filter=${JSON.stringify(filter)}`;

        $http.get(`${API_URL}/api/vehicles/vehicles${query}`)
          .then((result) => {
            scope.ready = true;
            scope.saveCars(result.data);
          })
          .catch((e) => {
            console.error(e);
          });

        scope.$watch('carInit', (newValue) => {
          scope.initCar(newValue);
        }, true);
      },
    };
  })
  .name;
